/* eslint-disable no-plusplus */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { ColPresetType } from '../../../redux/clientConfiguration/clientConfigurationSlice';
import { StructureType } from '../../../types/types';
import { getCookieCustom } from '../../../utils/cookies';

export const updateConfData = (id: string, data: any, parameter: string) =>
 //  console.log('updateConfData', {
 //   id,
 //   data: {
 //    Name: getCookieCustom('user_id') || -1,
 //    Parameter: parameter,
 //    Type: 'string',
 //    Value: JSON.stringify(data),
 //   },
 //  });
 ({
  id,
  data: {
   Name: getCookieCustom('user_id') || -1,
   Parameter: parameter,
   Type: 'string',
   Value: JSON.stringify(data),
  },
 });

export const sortStructure = (structure: StructureType[]) =>
 structure.slice().sort((obj1, obj2) => {
  if (
   ['model', 'array'].includes(obj1.Type) &&
   !['model', 'array'].includes(obj2.Type)
  ) {
   return -1; // obj1 comes before obj2
  }
  if (
   !['model', 'array'].includes(obj1.Type) &&
   ['model', 'array'].includes(obj2.Type)
  ) {
   return 1; // obj2 comes before obj1
  }
  return 0; // maintain relative order otherwise
 });

export const isSelected = (key: string, selected: ColPresetType | null) =>
 selected?.columns?.map((col) => col.field).includes(key) || false;

export const filterStructureForSearch = (
 data: StructureType[],
 text: string,
): StructureType[] =>
 data?.reduce((acc: StructureType[], item: StructureType) => {
  if (
   item.Translation.toLowerCase().includes(text.toLowerCase()) ||
   (item.InnerStructure &&
    filterStructureForSearch(item.InnerStructure, text).length > 0)
  ) {
   acc.push({
    ...item,
    InnerStructure: item.InnerStructure
     ? filterStructureForSearch(item.InnerStructure, text)
     : [],
   });
  }
  return acc;
 }, []) || [];

export const filterStructureForExpanded = (
 data: StructureType[],
 depth = 1,
): string[] => {
 let result: string[] = [];
 for (const item of data) {
  const depthKey = `${depth}_${item.Name}`;
  if (['model', 'array'].includes(item.Type)) {
   result.push(depthKey);
  }
  if (Array.isArray(item.InnerStructure) && item.InnerStructure.length > 0) {
   result = result.concat(
    filterStructureForExpanded(item.InnerStructure, depth + 1),
   );
  }
 }
 return result;
};
